// Simulated SF reports for the guided tour — no API calls, no real data
const now = Date.now();
const ago = (minutes) => new Date(now - minutes * 60 * 1000).toISOString();

export const SF_TOUR_REPORTS = [
  {
    id: 'tour-001',
    description: 'Was followed by a man from Powell St BART exit all the way to Market St — continued for 3 blocks before I entered a store to lose him.',
    type: 'level3',
    latitude: 37.7844,
    longitude: -122.4079,
    timestamp: ago(45),
    upvoteCount: 12,
    verifiedByModerator: true,
    createdBy: 'tour-user-a',
    creatorName: 'Anonymous',
    source: 'user',
    address: 'Powell St & Market St, Union Square',
    comments: [
      { id: 'c1', text: 'This happened to me in the same spot two weeks ago, around the same time of night.', userName: 'Anonymous', timestamp: ago(30), isAnonymous: true },
      { id: 'c2', text: 'Moderator confirmed: SFPD patrol has been notified of this block.', userName: 'Moderator_J', timestamp: ago(20), isAnonymous: false },
    ],
  },
  {
    id: 'tour-002',
    description: 'Poorly lit alley between Turk and Eddy — two street lights out, no foot traffic. Felt unsafe walking home from work.',
    type: 'level2',
    latitude: 37.7831,
    longitude: -122.4124,
    timestamp: ago(120),
    upvoteCount: 8,
    verifiedByModerator: false,
    createdBy: 'tour-user-b',
    creatorName: 'Anonymous',
    source: 'user',
    address: 'Turk St, Tenderloin',
    comments: [],
  },
  {
    id: 'tour-003',
    description: 'Man became aggressive at 16th & Mission BART plaza after I declined to give money. Followed me up the escalator.',
    type: 'level3',
    latitude: 37.7650,
    longitude: -122.4197,
    timestamp: ago(200),
    upvoteCount: 19,
    verifiedByModerator: true,
    createdBy: 'tour-user-c',
    creatorName: 'Anonymous',
    source: 'user',
    address: '16th St Mission BART, Mission District',
    comments: [
      { id: 'c3', text: 'I saw this too — he was there most of the evening.', userName: 'Anonymous', timestamp: ago(150), isAnonymous: true },
    ],
  },
  {
    id: 'tour-004',
    description: 'Noticed a man following me on Haight St from Ashbury to Masonic. Crossed the street twice and he mirrored me both times.',
    type: 'level3',
    latitude: 37.7692,
    longitude: -122.4481,
    timestamp: ago(90),
    upvoteCount: 6,
    verifiedByModerator: true,
    createdBy: 'tour-user-d',
    creatorName: 'Anonymous',
    source: 'user',
    address: 'Haight St & Masonic Ave, Haight-Ashbury',
    comments: [],
  },
  {
    id: 'tour-005',
    description: 'Three street lights broken on the 600 block of Folsom — very dark stretch. Would not walk this alone at night.',
    type: 'level1',
    latitude: 37.7810,
    longitude: -122.3970,
    timestamp: ago(480),
    upvoteCount: 4,
    verifiedByModerator: false,
    createdBy: 'tour-user-e',
    creatorName: 'Anonymous',
    source: 'user',
    address: 'Folsom St, SoMa',
    comments: [],
  },
  {
    id: 'tour-006',
    description: 'Verbal harassment outside Castro Station. Man made threatening comments as I exited, then waited near the entrance.',
    type: 'level2',
    latitude: 37.7621,
    longitude: -122.4350,
    timestamp: ago(300),
    upvoteCount: 11,
    verifiedByModerator: true,
    createdBy: 'tour-user-f',
    creatorName: 'Anonymous',
    source: 'user',
    address: 'Castro St Station, The Castro',
    comments: [
      { id: 'c4', text: 'Same description matched a report from last Thursday.', userName: 'Moderator_K', timestamp: ago(250), isAnonymous: false },
    ],
  },
  {
    id: 'tour-007',
    description: 'Crosswalk signal broken at Market & Octavia — no audio signal for visually impaired and walk light is barely visible.',
    type: 'level1',
    latitude: 37.7741,
    longitude: -122.4241,
    timestamp: ago(720),
    upvoteCount: 3,
    verifiedByModerator: false,
    createdBy: 'tour-user-g',
    creatorName: 'Anonymous',
    source: 'user',
    address: 'Market St & Octavia Blvd',
    comments: [],
  },
  {
    id: 'tour-008',
    description: 'Followed from Trader Joe\'s on Bay St back to my car in the parking structure. Man waited outside my car for several minutes.',
    type: 'level3',
    latitude: 37.8030,
    longitude: -122.4364,
    timestamp: ago(60),
    upvoteCount: 15,
    verifiedByModerator: true,
    createdBy: 'tour-user-h',
    creatorName: 'Anonymous',
    source: 'user',
    address: 'Bay St, Marina District',
    comments: [
      { id: 'c5', text: 'Reported to building security. They have footage.', userName: 'Anonymous', timestamp: ago(40), isAnonymous: true },
    ],
  },
  {
    id: 'tour-009',
    description: 'Threatening behavior at Civic Center BART plaza — group of men blocking the entrance, targeting women entering alone.',
    type: 'level3',
    latitude: 37.7794,
    longitude: -122.4145,
    timestamp: ago(150),
    upvoteCount: 23,
    verifiedByModerator: true,
    createdBy: 'tour-user-i',
    creatorName: 'Anonymous',
    source: 'user',
    address: 'Civic Center BART, Civic Center',
    comments: [
      { id: 'c6', text: 'BART police alerted. Station agent asked the group to move.', userName: 'Moderator_J', timestamp: ago(100), isAnonymous: false },
    ],
  },
  {
    id: 'tour-010',
    description: 'Parking lot under Ferry Building completely unlit after 9pm. Security camera appeared non-functional.',
    type: 'level1',
    latitude: 37.7955,
    longitude: -122.3937,
    timestamp: ago(600),
    upvoteCount: 5,
    verifiedByModerator: false,
    createdBy: 'tour-user-j',
    creatorName: 'Anonymous',
    source: 'user',
    address: 'Embarcadero, Ferry Building',
    comments: [],
  },
  {
    id: 'tour-011',
    description: 'Persistent verbal harassment walking on Valencia St between 20th and 21st. Man followed for one block making threatening comments.',
    type: 'level2',
    latitude: 37.7588,
    longitude: -122.4213,
    timestamp: ago(180),
    upvoteCount: 9,
    verifiedByModerator: false,
    createdBy: 'tour-user-k',
    creatorName: 'Anonymous',
    source: 'user',
    address: 'Valencia St, Mission District',
    comments: [],
  },
  {
    id: 'tour-012',
    description: 'Suspicious man photographing women near Dolores Park main entrance at 18th St. Became hostile when I asked him to stop.',
    type: 'level2',
    latitude: 37.7596,
    longitude: -122.4269,
    timestamp: ago(240),
    upvoteCount: 7,
    verifiedByModerator: true,
    createdBy: 'tour-user-l',
    creatorName: 'Anonymous',
    source: 'user',
    address: 'Dolores Park, 18th St entrance',
    comments: [],
  },
  {
    id: 'tour-013',
    description: 'Followed from UCSF Parnassus campus to bus stop on Irving. Man waited at the stop and kept approaching despite being told to stop.',
    type: 'level3',
    latitude: 37.7631,
    longitude: -122.4586,
    timestamp: ago(360),
    upvoteCount: 14,
    verifiedByModerator: true,
    createdBy: 'tour-user-m',
    creatorName: 'Anonymous',
    source: 'user',
    address: 'Parnassus Ave, Inner Sunset / UCSF',
    comments: [],
  },
  {
    id: 'tour-014',
    description: 'Stalking incident in North Beach — same man appeared at three separate locations over 2 hours. Called a friend to walk with me.',
    type: 'level3',
    latitude: 37.8006,
    longitude: -122.4103,
    timestamp: ago(420),
    upvoteCount: 17,
    verifiedByModerator: true,
    createdBy: 'tour-user-n',
    creatorName: 'Anonymous',
    source: 'user',
    address: 'Columbus Ave, North Beach',
    comments: [
      { id: 'c7', text: 'Description matches a report from this area last month. Escalating to SFPD.', userName: 'Moderator_K', timestamp: ago(380), isAnonymous: false },
    ],
  },
  {
    id: 'tour-015',
    description: 'Bus shelter at Geary & Divisadero has no lighting and the bench is broken — only place to wait on a 15-minute gap route.',
    type: 'level1',
    latitude: 37.7841,
    longitude: -122.4388,
    timestamp: ago(900),
    upvoteCount: 2,
    verifiedByModerator: false,
    createdBy: 'tour-user-o',
    creatorName: 'Anonymous',
    source: 'user',
    address: 'Geary Blvd & Divisadero St',
    comments: [],
  },
];

// The spotlight report for step 1 — auto-opened during tour
export const TOUR_SPOTLIGHT_REPORT_ID = 'tour-001';

// SF map center for tour
export const SF_CENTER = { lat: 37.7749, lng: -122.4194 };
export const SF_ZOOM = 13;
